<template>
  <v-card
    class="px-3 py-0"
  >
    <v-list
      class="my-0 py-0"
    >
      <template
        v-for="(item, index) in items"
      >
        <v-divider
          v-if="index > 0"
          :key="'div' + index"
        />
        <v-list-item
          
          :key="index"
          :to="item.to"
        >
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { Order } from '@/models'
import { mapGetters } from 'vuex'

export default {
  computed: {
    orderCount () {
      return Order.all().length
    },
    ...mapGetters(['rewards']),
    items () {
      return [
        {
          name: 'Account Info',
          to: { name: 'AccountInfo' }
        },
        {
          name: 'Address Book',
          to: { name: 'AddressBook' }
        },
        {
          name: `Orders${this.orderCount > 0 ? ' (' + this.orderCount + ')' : ''}`,
          to: { name: 'Orders' }
        }
      ]
    }
  }
}
</script>
